// Tracking service to handle all analytics loading
import { watchPopupJourney } from './popupJourney';
import { ensureVisitorId } from './visitorId';
import {
  AnalyticsProvider,
  SegmentProvider,
  GoogleAnalyticsProvider,
  GAConnectorProvider,
  FullStoryProvider,
} from './providers';

class TrackingService {
  private static instance: TrackingService;
  private providers: AnalyticsProvider[] = [];
  private isLoaded = false;

  private constructor() {}

  static getInstance(): TrackingService {
    if (!TrackingService.instance) {
      TrackingService.instance = new TrackingService();
    }
    return TrackingService.instance;
  }

  private shouldLoadTracking(): boolean {
    if (process.env.REACT_APP_USE_SKIP_SEGMENT === 'true') {
      console.log('Development mode: Tracking scripts disabled');
      return false;
    }

    if (this.isLoaded) {
      console.log('Tracking scripts already loaded');
      return false;
    }

    return true;
  }

  public initialize(): void {
    if (!this.shouldLoadTracking()) {
      return;
    }

    console.log('Loading tracking scripts...');

    try {
      ensureVisitorId();
      // Initialize providers
      this.providers = [
        new GAConnectorProvider(),
        new SegmentProvider(),
        new GoogleAnalyticsProvider(),
        new FullStoryProvider(),
      ];

      // Load all providers
      this.providers.forEach((provider) => {
        if ('initialize' in provider) {
          provider.initialize();
        }
      });

      this.isLoaded = true;
      watchPopupJourney((event, properties) => this.track(event, properties));
      console.log('All tracking scripts loaded successfully');
    } catch (error) {
      console.error('Error loading tracking scripts:', error);
    }
  }

  // Unified tracking methods
  public track(event: string, properties?: Record<string, any>): void {
    this.providers.forEach((provider) => {
      if ('track' in provider) {
        provider.track(event, properties);
      }
    });
  }

  public identify(userId: string, traits?: Record<string, any>): void {
    this.providers.forEach((provider) => {
      if ('identify' in provider) {
        provider.identify(userId, traits);
      }
    });
  }

  public page(name?: string, properties?: Record<string, any>): void {
    this.providers.forEach((provider) => {
      if ('page' in provider) {
        provider.page(name, properties);
      }
    });
  }

  public isTrackingLoaded(): boolean {
    return this.isLoaded;
  }
}

export default TrackingService;
